export default "__VITE_PUBLIC_ASSET__a8c5bfa4__"